import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstanceJson from "../../../AxiosInstance/axiosInstanceJson";
import axiosInstancecentralJson from "../../../AxiosInstance/axiosInstancecentralJson";
import axiosInstance from "../../../AxiosInstance/axiosInstance";
import axios from "axios";
import { config } from "../../../config/config";
import Cookies from "js-cookie";

export const getActiveSurname = createAsyncThunk(
  "surname/getActiveSurname",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstanceJson.get(
        `/v1/admin/user/get-surname`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getBloodGroup = createAsyncThunk(
  "bloodGroup/getActiveSurname",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstanceJson.get(
        `/v1/admin/bloodGroup/get-bloodGroup`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getActiveBusiness = createAsyncThunk(
  "business/getActiveBusiness",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstanceJson.get(
        `/v1/admin/business/get_business`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getActiveJob = createAsyncThunk(
  "job/getActiveJob",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstanceJson.get(`/v1/admin/job/get_job`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getActiveDegree = createAsyncThunk(
  "Degree/getActiveJob",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstanceJson.get(
        `/v1/admin/degree/get_degree`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const createUser = createAsyncThunk(
  "User/createUser",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `/v1/admin/user/create-user`,
        formData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getUser = createAsyncThunk(
  "User/getUsers",
  async (
    {
      id,
      status = "All",
      search = "",
      page = 1,
      limit = 10,
      startDate,
      endDate,
      paginate,
    },
    thunkAPI
  ) => {
    try {
      const { data } = await axiosInstanceJson.get(`/v1/admin/user/get-user`, {
        params: {
          id,
          status,
          search,
          page,
          limit,
          startDate,
          endDate,
          paginate,
        },
      });

      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Error occurred");
    }
  }
);

export const updateUser = createAsyncThunk(
  "User/updateUser",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `/v1/admin/user/update-user/${id}`,
        formData
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getUserById = createAsyncThunk(
  "Users/getById",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstanceJson.get(
        `/v1/admin/user/get-userById/${id}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const deleteUser = createAsyncThunk(
  "Users/delete",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstanceJson.delete(
        `/v1/admin/user/delete-user/${id}`
      );
      return { id, data };
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const undoDeleteUser = createAsyncThunk(
  "Surname/undoDelete",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstanceJson.put(
        `/v1/admin/user/undodelete-user/${id}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getCountry = createAsyncThunk(
  "Country/getCountry",
  async (_, thunkAPI) => {
    try {
      const { data } = await axiosInstancecentralJson.get(
        `/v1/master/location/get-country`,
        {
          headers: {
            "access-key":
              "vfdf2g6dbsdffb6fd1b6dbeg2ver6g1_dsf6e1_dsfv62s51wqddS_RT4RHYLHJ",
          },
        }
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getStatesByCountry = createAsyncThunk(
  "Country/getStatesByCountry",
  async (countryId, thunkAPI) => {
    try {
      const { data } = await axiosInstancecentralJson.get(
        `/v1/master/location/get-states/${countryId}`,
        {
          headers: {
            "access-key":
              "vfdf2g6dbsdffb6fd1b6dbeg2ver6g1_dsf6e1_dsfv62s51wqddS_RT4RHYLHJ",
          },
        }
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getDistrictsByState = createAsyncThunk(
  "Country/getDistrictsByState",
  async (stateId, thunkAPI) => {
    try {
      const { data } = await axiosInstancecentralJson.get(
        `/v1/master/location/get-district/${stateId}`,
        {
          headers: {
            "access-key":
              "vfdf2g6dbsdffb6fd1b6dbeg2ver6g1_dsf6e1_dsfv62s51wqddS_RT4RHYLHJ",
          },
        }
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getTalukaByDistrict = createAsyncThunk(
  "Country/getTalukaByDistrict",
  async (districtId, thunkAPI) => {
    try {
      const { data } = await axiosInstancecentralJson.get(
        `/v1/master/location/get-taluka/${districtId}`,
        {
          headers: {
            "access-key":
              "vfdf2g6dbsdffb6fd1b6dbeg2ver6g1_dsf6e1_dsfv62s51wqddS_RT4RHYLHJ",
          },
        }
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getVillagesByDistrict = createAsyncThunk(
  "Country/getVillagesByDistrict",
  async (talukaId, thunkAPI) => {
    try {
      const { data } = await axiosInstancecentralJson.get(
        `/v1/master/location/get-village/${talukaId}`,
        {
          headers: {
            "access-key":
              "vfdf2g6dbsdffb6fd1b6dbeg2ver6g1_dsf6e1_dsfv62s51wqddS_RT4RHYLHJ",
          },
        }
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const createCountry = createAsyncThunk(
  "location/createCountry",
  async (countryData, thunkAPI) => {
    try {
      const response = await axiosInstancecentralJson.post(
        "/v1/master/location/create-country",
        countryData,
        {
          headers: {
            "access-key":
              "vfdf2g6dbsdffb6fd1b6dbeg2ver6g1_dsf6e1_dsfv62s51wqddS_RT4RHYLHJ",
          },
        }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const createState = createAsyncThunk(
  "location/createState",
  async (stateData, thunkAPI) => {
    try {
      const response = await axiosInstancecentralJson.post(
        "/v1/master/location/create-state",
        stateData,
        {
          headers: {
            "access-key":
              "vfdf2g6dbsdffb6fd1b6dbeg2ver6g1_dsf6e1_dsfv62s51wqddS_RT4RHYLHJ",
          },
        }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const createDistrict = createAsyncThunk(
  "location/createDistrict",
  async (districtData, thunkAPI) => {
    try {
      const response = await axiosInstancecentralJson.post(
        "/v1/master/location/create-district",
        districtData,
        {
          headers: {
            "access-key":
              "vfdf2g6dbsdffb6fd1b6dbeg2ver6g1_dsf6e1_dsfv62s51wqddS_RT4RHYLHJ",
          },
        }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const createTaluka = createAsyncThunk(
  "location/createTaluka",
  async (talukaData, thunkAPI) => {
    try {
      const response = await axiosInstancecentralJson.post(
        "/v1/master/location/create-taluka",
        talukaData,
        {
          headers: {
            "access-key":
              "vfdf2g6dbsdffb6fd1b6dbeg2ver6g1_dsf6e1_dsfv62s51wqddS_RT4RHYLHJ",
          },
        }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const createVillage = createAsyncThunk(
  "location/createVillage",
  async (villageData, thunkAPI) => {
    try {
      const response = await axiosInstancecentralJson.post(
        "/v1/master/location/create-village",
        villageData,
        {
          headers: {
            "access-key":
              "vfdf2g6dbsdffb6fd1b6dbeg2ver6g1_dsf6e1_dsfv62s51wqddS_RT4RHYLHJ",
          },
        }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const createBusiness = createAsyncThunk(
  "profession/createBusiness",
  async (businessData, thunkAPI) => {
    try {
      const response = await axiosInstancecentralJson.post(
        "/v1/master/profession/create-business",
        businessData,
        {
          headers: {
            "access-key":
              "vfdf2g6dbsdffb6fd1b6dbeg2ver6g1_dsf6e1_dsfv62s51wqddS_RT4RHYLHJ",
          },
        }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const createJob = createAsyncThunk(
  "profession/createJob",
  async (jobData, thunkAPI) => {
    try {
      const response = await axiosInstancecentralJson.post(
        "/v1/master/profession/create-job",
        jobData,
        {
          headers: {
            "access-key":
              "vfdf2g6dbsdffb6fd1b6dbeg2ver6g1_dsf6e1_dsfv62s51wqddS_RT4RHYLHJ",
          },
        }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const createDegree = createAsyncThunk(
  "profession/createDegree",
  async (studyData, thunkAPI) => {
    try {
      const response = await axiosInstancecentralJson.post(
        "/v1/master/profession/create-study",
        studyData,
        {
          headers: {
            "access-key":
              "vfdf2g6dbsdffb6fd1b6dbeg2ver6g1_dsf6e1_dsfv62s51wqddS_RT4RHYLHJ",
          },
        }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getBusiness = createAsyncThunk(
  "Business/getBusiness",
  async (_, thunkAPI) => {
    try {
      const { data } = await axiosInstancecentralJson.get(
        `/v1/master/profession/get-business`,
        {
          headers: {
            "access-key":
              "vfdf2g6dbsdffb6fd1b6dbeg2ver6g1_dsf6e1_dsfv62s51wqddS_RT4RHYLHJ",
          },
        }
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getJob = createAsyncThunk("Job/getJob", async (_, thunkAPI) => {
  try {
    const { data } = await axiosInstancecentralJson.get(
      `/v1/master/profession/get-job`,
      {
        headers: {
          "access-key":
            "vfdf2g6dbsdffb6fd1b6dbeg2ver6g1_dsf6e1_dsfv62s51wqddS_RT4RHYLHJ",
        },
      }
    );
    return data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const getDegree = createAsyncThunk(
  "Degree/getDegree",
  async (_, thunkAPI) => {
    try {
      const { data } = await axiosInstancecentralJson.get(
        `/v1/master/profession/get-study`,
        {
          headers: {
            "access-key":
              "vfdf2g6dbsdffb6fd1b6dbeg2ver6g1_dsf6e1_dsfv62s51wqddS_RT4RHYLHJ",
          },
        }
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getMemberByMainMember = createAsyncThunk(
  "business/getActiveBusiness",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstanceJson.get(
        `/v1/admin/user/get_users_by_mainMember/${id}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getOnlineUser = createAsyncThunk(
  "users/getOnlineUser",
  async (params, { rejectWithValue }) => {
    try {
      const response = await axiosInstanceJson.get(
        `/v1/admin/user/get_online_user`,
        {
          params, // Pass page, limit, etc. properly
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getDialCode = createAsyncThunk(
  "DialCode/getDialCode",
  async (_, thunkAPI) => {
    try {
      const { data } = await axiosInstancecentralJson.get(
        `/v1/master/dialCode/get_dialCode`,
        {
          headers: {
            "access-key":
              "vfdf2g6dbsdffb6fd1b6dbeg2ver6g1_dsf6e1_dsfv62s51wqddS_RT4RHYLHJ",
          },
        }
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const createUserRequest = createAsyncThunk(
  "User/createUserRequest",
  async (formData, { rejectWithValue }) => {
    try {
      const token = Cookies.get("authToken");
      const response = await axios({
        method: "post",
        url: `${config.base.url}/v1/user/userAddRequest/create-user-request`,
        data: formData,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      // Prevent automatic navigation by not throwing the error
      if (error.response?.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue({
        message: "ફોર્મ સબમિટ કરવામાં ભૂલ આવી છે",
        errors: {},
      });
    }
  }
);

export const getUserRequest = createAsyncThunk(
  "userRequest/getUsersRequest",
  async (
    {
      id,
      status = "All",
      search = "",
      page = 1,
      limit = 10,
      startDate,
      endDate,
      paginate,
    },
    thunkAPI
  ) => {
    try {
      const { data } = await axiosInstanceJson.get(
        `/v1/user/userAddRequest/get-user-request`,
        {
          params: {
            id,
            status,
            search,
            page,
            limit,
            startDate,
            endDate,
            paginate,
          },
        }
      );

      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Error occurred");
    }
  }
);

export const acceptUserRequest = createAsyncThunk(
  "userRequest/acceptUserRequest",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstanceJson.post(
        `/v1/user/userAddRequest/accept-request/${id}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateRegistrationLink = createAsyncThunk(
  "registrationLink/updateRegistrationLink",
  async ({ status }, { rejectWithValue }) => {
    try {
      const response = await axiosInstanceJson.put(
        `/v1/user/registrationLink/updateLinkStatus`,
        { status }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deletetUserRequest = createAsyncThunk(
  "userRequest/acceptUserRequest",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstanceJson.delete(
        `/v1/user/userAddRequest/delete-user/${id}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getUserRequestById = createAsyncThunk(
  "userRequest/getById",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstanceJson.get(
        `/v1/user/userAddRequest/get-userById/${id}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const updateUserRequest = createAsyncThunk(
  "userRequest/updateUser",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `/v1/user/userAddRequest/update_user/${id}`,
        formData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
